import React from "react";
import wabes from './styles//images/download.svg';
import './styles/PCA.css';
import PCA_img1 from './styles/images/PCA-service1-1.jpg';
import TestimonialMarquee from "./testimonialmarquee";
import PCA_img2 from './styles/images/PCA-service.jpg';
import PCA_img3 from './styles/images/PCA-service1.jpg';
import NewsTicker from "./marequee";
import Footer from "./Footer";
function PCA() {
    return (
        <>
            <section id="about4" className="about">
                <div className="wrap"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">

                            <h1 className="heading"> <span className="hero-highlight">Personal Care Assistance (PCA)</span>  <br /> Compassionate In-Home <span className="hero-highlight">Support</span></h1>
                            <p className="supporting">
                                Providing personalized and dedicated care to help individuals with daily activities.
                            </p>
                        </div>
                    </div>
                </div>
                <img src={wabes} alt="Waves" id="waves1" />
            </section>
            <section id="about-des">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h1>
                                Fact about <span className="hero-highlight" >PCA</span> Services
                            </h1>
                            <p className="mt-5">
                                The <strong>State of Minnesota</strong> offers various programs to assist older adults and individuals with disabilities in remaining in their homes rather than moving to a facility. One such program is the <strong>Personal Care Assistance (PCA) Program</strong>, managed by the <strong>Minnesota Department of Human Services</strong>. Established in 1978, the PCA Program was introduced when Minnesota modified its Medical Assistance Program to include personal home care support.
                            </p>

                            <p className="mt-2">
                                <strong>PCA services</strong> provide essential <strong>home care assistance</strong> to individuals across Minnesota, helping them with non-medical, health-related tasks and daily living activities. The primary goal of PCA services is to promote independence, allowing individuals to remain in their homes and communities rather than transitioning to institutional care.
                            </p>

                            <p className="mt-2 font-weight-bold">
                                Available for people of all ages with special healthcare needs, <strong>PCA services</strong> are a covered benefit under the <strong>Medical Assistance or MinnesotaCare Program</strong>. These services can be accessed through fee-for-service programs, Home and Community-Based Services (HCBS) waiver programs, or prepaid health plans like UCare.
                            </p>


                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <img src={PCA_img1} alt="PCA image of the Samah home Care | Samah Homes" width={'95%'} height={'100%'} />
                        </div>
                    </div>
                </div>
            </section>
            <section className="m-5">
            <section class="services-container">
    <div class="card3">
        <h3>Meal Preparation</h3>
        <p>We prepare delicious and nutritious meals for our patients to enjoy. We carefully select the food or ingredients to ensure that they receive the right amount of nutrients their body needs.</p>
    </div>

    <div class="card3">
        <h3>Eating Assistance</h3>
        <p>We make sure that our patients are properly fed, assisted with hand washing, and assisted with the application of orthotics as needed for eating.</p>
    </div>

    <div class="card3">
        <h3>Grooming & Dressing</h3>
        <p>We assist patients with their personal care such as putting on clean clothes, hair care, nail care, oral care, deodorant, eyeglasses, hearing aids, etc.</p>
    </div>

    <div class="card3">
        <h3>Bathing Assistance</h3>
        <p>We provide assistance with their bath from start to finish and assist them with mobility and transferring to prevent slips or falls.</p>
    </div>

    <div class="card3">
        <h3>Toileting</h3>
        <p>We assist patients with their mobility, bowel/bladder elimination and care, etc.</p>
    </div>

    <div class="card3">
        <h3>Light Housekeeping</h3>
        <p>We ensure that our patient's home is clean and organized to create a conducive recovery environment.</p>
    </div>

    <div class="card3">
        <h3>Mobility & Transferring</h3>
        <p>We assist patients with their mobility, helping them move from one place to another to prevent fall accidents.</p>
    </div>

    <div class="card3">
        <h3>Medication Reminders</h3>
        <p>We ensure that our patients do not skip their medication doses and monitor their progress regularly.</p>
    </div>

    <div class="card3">
        <h3>Health-Related Functions</h3>
        <p>We provide around-the-clock supervision and monitoring to ensure visible progress in their health.</p>
    </div>

    {/* <div class="card3">
        <h3>Running Errands</h3>
        <p>We can run errands such as grocery shopping, paying bills, and other tasks whenever needed.</p>
    </div> */}

    <div class="card3">
        <h3>Accompany to Appointments</h3>
        <p>We assist and accompany patients to doctor’s appointments, outings, malls, parks, friends’ houses, and any destination of their choice.</p>
    </div>
</section>

            </section>
            <section id="PCA_links">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12" id="PCA-Links" data-aos="fade-up">
                            <h2>
                                <span className="hero-highlight">Home Care Services</span> Offered Under the PCA Program:
                            </h2>
                            <div className="Links-to" data-aos="slide-up">
                                <h4>
                                    <a href="https://www.dhs.state.mn.us/main/idcplg?IdcService=GET_DYNAMIC_CONVERSION&RevisionSelectionMethod=LatestReleased&dDocName=PCA_Home">
                                        Traditional PCA Option (PCPO):
                                    </a>

                                </h4>
                                <p>
                                    Under this program, clients receiving PCA services obtain a personal care assistant through a PCA agency, like Best Care, that hires, trains, pays, and schedules the hours for care.
                                </p>

                            </div>
                            <h5>


                                To provide greater flexibility and accommodate the evolving needs of individuals receiving care, Minnesota’s PCA program also offers home care services through various delivery models, as outlined below.
                            </h5>
                            <div className="Links-to" data-aos="slide-up">
                                <h4>
                                    <a href="https://www.dhs.state.mn.us/main/idcplg?IdcService=GET_DYNAMIC_CONVERSION&RevisionSelectionMethod=LatestReleased&dDocName=PCA_Home">
                                        PCA Choice Option:
                                    </a>

                                </h4>
                                <p>
                                    The PCA Choice program allows individuals requiring home care services to independently select and train a Personal Care Assistant (PCA) to meet their specific needs. This option provides clients with greater control and responsibility over their care while the PCA agency manages employment and administrative tasks. Under Minnesota’s PCA Choice program, the agency serves as the official employer of record for PCAs.
                                </p>

                            </div>
                            <div className="Links-to" data-aos="slide-up">
                                <h4>
                                    <a href="https://www.dhs.state.mn.us/main/idcplg?IdcService=GET_DYNAMIC_CONVERSION&RevisionSelectionMethod=LatestReleased&dDocName=dhs16_146085">
                                        Shared Care Option:
                                    </a>

                                </h4>
                                <p>
                                    The Shared Care Option allows one PCA worker to help two or three individuals living in the same setting.
                                </p>

                            </div>
                            <div className="Links-to" data-aos="slide-up">
                                <h4>
                                    <a href="https://www.dhs.state.mn.us/main/idcplg?IdcService=GET_DYNAMIC_CONVERSION&RevisionSelectionMethod=LatestReleased&dDocName=PCA_Home">
                                        Flexible Use Option:
                                    </a>
                                </h4>
                                <p>
                                    With the Flexible Use Option, clients can allocate their approved PCA hours as needed within a designated service authorization period, allowing for greater adaptability to their changing needs and schedules.                            </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="about-des1">

                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3>Who Qualifies for <span className="hero-highlight">PCA</span> Services?</h3>
                        <p>To be eligible for PCA services, an individual must meet the following criteria:</p>

                        <ul>
                            <li><strong>Reside in Minnesota</strong></li>
                            <li><strong>Qualify for medical assistance or MinnesotaCare</strong> (including pregnant women and children under 21)</li>
                            <li><strong>Be capable of making personal care decisions</strong> or have a designated representative to do so</li>
                            <li><strong>Complete an assessment</strong> conducted by a Public Health Nurse (PHN) from their county</li>
                            <li><strong>Require hands-on assistance or continuous supervision</strong> for at least one Activity of Daily Living (ADL) or have Level 1 Behavior</li>
                        </ul>

                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <img src={PCA_img2} alt=" An img of a Samah Home care | Samah Home care" width={'100%'} height={'100%'} />
                    </div>
                </div>
                

            </section>
            <section>
                <div className="container mb-5">
                <div className="row ">
                    <NewsTicker />
                </div>
                </div>
               

            </section>
            <footer>
                <Footer />
            </footer>
        </>
    )
}
export default PCA;